import __request__ from "routing/request";
export function history(count = 5, before, requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.assistant/assistant", null, { "count": count, "before": before }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function widgetSummaryAvailability(widgetType, requestOptions) {
  return __request__("GET", `/plugins/org.graylog.plugins.assistant/assistant/widget-summary/${widgetType}/availability`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
